module.exports = __webpack_public_path__ + "images/pro/img-pro-storage@2x-7c2e24e9eb6b1745de231b502517a77f.png";